export default __webpack_public_path__ + "resources/icons/n300-f6f2.png";